import { render, staticRenderFns } from "./masterAdminApp.vue?vue&type=template&id=04e17bda&"
import script from "./masterAdminApp.vue?vue&type=script&lang=js&"
export * from "./masterAdminApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports